export const PLAN_NOT_ALLOWED = 'plan-not-allowed'
export const FEATURE_NOT_ALLOWED = 'feature-not-allowed'
